import React from 'react';
import PropTypes from 'prop-types';
import Gravatar from 'react-gravatar';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
// our components
import userInfoStyle from 'assets/jss/InfoUser';
import { getUserPhotoUrl } from 'helpers/functions';

/**
 * @description
 * Stateless component.
 *
 * @param {Object} props - Component props.
 */
const InfoUser = ({ user, classes }) => (
  <div className={classes.container}>
    <div key="logged-avatar">
      {user.photo ? (
        <img
          className={classes.avatar}
          src={getUserPhotoUrl(user.photo)}
          alt="Avatar"
        />
      ) : (
        <Gravatar
          className={classes.avatar}
          email={user.email || user.fullname}
        />
      )}
    </div>
    <div key="logged-user">
      <p className={classes.userName}>{user.fullname}</p>
      <p>
        {user.rank && `${user.rank} • `} {user.email}
      </p>
    </div>
  </div>
);

/**
 * InfoUser PropTypes
 * @param classes - prop styles received from withStyles
 * @param user - prop user info received from parents
 */

InfoUser.propTypes = {
  user: PropTypes.instanceOf(Object).isRequired,
  classes: PropTypes.instanceOf(Object).isRequired,
};

export default withStyles(userInfoStyle)(InfoUser);
